export default [
  {
    path: "/app/user/settings",
    name: "user-settings",
    component: () => import("../common/views/Settings.vue"),
    redirect: () => ({ name: "account-settings" }), // TODO: Update this to general settings route name when that is implemented.
    children: [
      {
        path: "account",
        name: "account-settings",
        component: () => import("../common/components/Settings/Account.vue")
      }
    ]
  }
];
